export enum AppFilterButtonType {
  LINK = 'LINK',
  BOLD = 'BOLD',
  PRIMARY_BUTTON = 'PRIMARY-BUTTON',
  SECONDARY_BUTTON = 'SECONDARY-BUTTON',
  SECONDARY_BUTTON_WITH_PERMISSIONS = 'SECONDARY-BUTTON-WITH-PERMISSIONS',
  DELETE_ALL_BUTTON = 'DELETE-ALL-BUTTON'
}

export interface AppFilterButton {
  id: string;
  title: string;
  type: AppFilterButtonType;
  isHidden?: boolean;
  isDisabled?: boolean;
  hasLoadingSpinner?: boolean;
  hasSpinner?: boolean;
  customClass?: string;
  auth?: string;
  desc?: string;
}
